import { searchInfo } from '@/pages/OperationManage/service';
import { getApptItemPageSearch } from '@/pages/OrderAdministrate/ItemController/service';
import { getMallCommodityCategory } from '@/pages/ShoppingManage/CommodityManger/service';
import type { DetailOptionItem, OptionItem } from './data.d';

/** ## 链接配置
 * urlType                链接类型：1-小程序页面、2-自定义 h5 页面、3-其他小程序、4-自定义页面、5-tabbar 页面、6-打开视频号直播
 * tabPageList            小程序 tabbar 页面列表
 * normalPageList         普通小程序页面列表
 * detailPageList         小程序详情页面列表
 * systemPageList         系统预设页面列表：包含 urlType 1、5 的部分链接、详情类页面需要额外配置
 * customizationPageList  自定义页面列表，通过接口请求
 * detailMap              详情类页面额外配置
 */

/** ### 商品详情页配置 */
const goodDetail: DetailOptionItem = {
  value: 'goodDetail',
  key: 'goodDetail',
  defaultMessage: '商品详情页',
  url: '/storeGoodDetail/goodDetail/goodDetail?id=',
  fetchApi: getMallCommodityCategory,
  keywordField: 'commodityTitle',
  query: { shelfStatus: 1 },
}
/** ### 预约服务详情页配置 */
const apptItemDetail: DetailOptionItem = {
  value: 'apptItemDetail',
  key: 'apptItemDetail',
  defaultMessage: '预约服务详情页',
  url: '/shopSubscribe/shopDetail/shopDetail?id=',
  fetchApi: getApptItemPageSearch,
  keywordField: 'itemTitle',
  query: { shelfStatus: 1 },
}
/** ### 资讯详情页配置 */
const infoDetail: DetailOptionItem = {
  value: 'infoDetail',
  key: 'infoDetail',
  defaultMessage: '资讯详情页',
  url: '/pageInformation/informationDetail/informationDetail?id=',
  fetchApi: searchInfo,
  keywordField: 'title',
  labelField: 'informationTitle',
  query: { publishStatus: 1 },
}
/** ### 详情页汇总 */
export const detailMap: Record<string, DetailOptionItem> = {
  goodDetail,
  apptItemDetail,
  infoDetail,
}

/** ### urlTypeList 链接类型列表
 * 仅使用类型 1、2、3、4、5，且 1、5 合并到系统预设中
 */
export const urlTypeList: OptionItem[] = [
  { value: 1, key: 'system', defaultMessage: '系统预设' },
  { value: 4, key: 'customization', defaultMessage: '自定义页面' },
  { value: 2, key: 'other', defaultMessage: 'h5页面' },
  { value: 3, key: 'mini', defaultMessage: '其他小程序' },
];

/** ### tabPageList 小程序 tabbar 页面列表 */
export const tabPageList: OptionItem[] = [
  { value: '/pageHome/pageIndex', key: 'homepage', defaultMessage: '首页' },
  { value: '/pageStore/pageStore', key: 'mall', defaultMessage: '商城主页' },
  { value: '/my/my', key: 'mine', defaultMessage: '个人中心' },
];

/** ### normalPageLIst 小程序普通页面列表 */
export const normalPageList: OptionItem[] = [
  { value: '/pageServiceAppoint/pageServiceAppoint', key: 'n0', defaultMessage: '服务预约主页' },
  { value: '/pagePersonalInfo/healthDocument/healthDocument', key: 'n1', defaultMessage: '健康档案页' },
  { value: '/pageBodyFatScale/pageMyEquipment', key: 'n2', defaultMessage: '我的设备页' },
  { value: '/pageMedicalReport/reportIndex/reportIndex', key: 'n3', defaultMessage: '体检报告页' },
];

/** ### 小程序详情页面列表 */
// export const detailPageList: OptionItem[] = [
//   { value: '/storeGoodDetail/goodDetail/goodDetail?id=', key: 'n4', defaultMessage: '商品详情页' },
//   { value: '/shopSubscribe/shopDetail/shopDetail?id=', key: 'n5', defaultMessage: '预约服务详情页' },
//   { value: '/pageInformation/informationDetail/informationDetail?id=', key: 'n6', defaultMessage: '资讯详情页' },
// ];
export const detailPageList: DetailOptionItem[] = Object.values(detailMap);

/** ### 系统预设页面列表
 * 1、包含
 */
export const systemPageList: OptionItem[] = [
  ...tabPageList,
  ...normalPageList,
  ...detailPageList,
];
